import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import MemoryViewModal from './components/MemoryViewModal';
import MetricsModal from './components/MetricsModal';
import LoginPage from './components/LoginPage';
import Home from './pages/Home';
import Advisor from './pages/Advisor';
import Strategy from './pages/Strategy';
import { AdvisorProvider } from './context/AdvisorContext';
import { isAuthenticated } from './auth';
import './App.css';

function App() {
  const [authed, setAuthed] = useState(null); // null = checking

  useEffect(() => {
    isAuthenticated()
      .then(ok => setAuthed(ok))
      .catch(() => setAuthed(false));
  }, []);

  if (authed === null) return null;
  if (!authed) {
    return <LoginPage onSuccess={() => setAuthed(true)} />;
  }

  return (
    <BrowserRouter>
      <AdvisorProvider>
        <div className="app-shell">
          <Sidebar />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<Advisor />} />
              <Route path="/home" element={<Home />} />
              <Route path="/strategy" element={<Strategy />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
          <MemoryViewModal />
          <MetricsModal />
        </div>
      </AdvisorProvider>
    </BrowserRouter>
  );
}

export default App;
